import {AppActions, AppActionType} from './app.types';
import { Industry, UserInfo, Country } from "../../util/interfaces";

export const initComplete = (): AppActionType => ({
  type: AppActions.INIT_COMPLETE
});

export const setUserInfo = (userInfo: UserInfo): AppActionType => ({
  type: AppActions.SET_USER_INFO,
  payload: userInfo,
});

export const setIsBusinessLogin = (flag: boolean): AppActionType => ({
  type: AppActions.SET_IS_BUSINESS_LOGIN,
  payload: flag,
});

export const clearUserInfo = (): AppActionType => ({
  type: AppActions.CLEAR_USER_INFO,
});

export const setSignupType = (signupType: string): AppActionType => ({
  type: AppActions.SET_SIGNUP_TYPE,
  payload: signupType,
});

export const parseParams = (url: string): AppActionType => ({
  type: AppActions.PARSE_PARAMS,
  payload: url,
})

export const removeParams = (targets: string[]): AppActionType => ({
  type: AppActions.REMOVE_PARAMS,
  payload: targets,
})

export const successClaimInvoice = (): AppActionType => ({
  type: AppActions.SUCCESS_CLAIM_INVOICE
})

export const failedClaimInvoice = (error: string): AppActionType => ({
  type: AppActions.FAILED_CLAIM_INVOICE,
  payload: error
})

export const setIsLoading = (loading: boolean): AppActionType => ({
  type: AppActions.SET_IS_LOADING,
  payload: loading
})

export const setIndustries = (industries: Industry[]): AppActionType => ({
  type: AppActions.SET_INDUSTRIES,
  payload: industries
})

export const setCountries = (countries: Country[]): AppActionType => ({
  type: AppActions.SET_COUNTRIES,
  payload: countries
})

/**
 * This should be used to add additional params to the request on finish-signup when redirecting from an affilate
 * like poynt.
 *
 * The way this would work is an affiliate would redirect to a specific endpoint, all that would happen at this end
 * point is a call to setExtendedRegistrationParams followed by a redirect to finish signup.
 *
 * Then when the finish signup effect is called these params will be automatically added to the request
 */
export const setExtendedRegistraionParams = (extendedParams: { [key: string]: any}): AppActionType => ({
  type: AppActions.SET_EXTENDED_REGISTRATION_PARAMS,
  payload: extendedParams
})
